<template>
  <div class="incubate">
    <common-layout>
      <div slot="header">
        <div class="incubate-tabs">
          <span
            v-for="item in tabs"
            :key="item.id"
            @click="handleClick(item.id)"
            :class="{ active_t: active == item.id }"
          >
            {{ item.name }}
          </span>
        </div>
        <ul class="incubate-nav">
          <li>内容管理</li>
          <li class="+active-Tab">双创载体</li>
        </ul>
      </div>
      <div slot="container">
        <!-- 技术人才库 -->
        <science v-if="active == 1"></science>
        <!-- 专家库 -->
        <specialist v-if="active == 2"></specialist>
        <!-- 企业库 -->
        <enterprise v-if="active == 3"></enterprise>
        <!-- 科研机构库 -->
        <mechanism v-if="active == 4"></mechanism>
        <!-- 创新平台库 -->
        <terrace v-if="active == 5"></terrace>
      </div>
    </common-layout>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../../components/common-layout.vue";
import science from "./science";
import specialist from "./specialist";
import enterprise from "./enterprise";
import mechanism from "./mechanism";
import terrace from "./terrace";

export default {
  components: {
    CommonLayout,
    science,
    specialist,
    enterprise,
    mechanism,
    terrace
  },
  data() {
    return {
      active: 1,
      tabs: [
        {
          id: 1,
          name: "技术人才库"
        },
        {
          id: 2,
          name: "专家库"
        },
        {
          id: 3,
          name: "企业库"
        },
        {
          id: 4,
          name: "科研机构库"
        },
        {
          id: 5,
          name: "创新平台库"
        },
      ]
    };
  },
  methods:{
    // 切换tab
			handleClick(val) {
				this.active = val;
				// this.searchValue = ''
				// this.type = ''
				// this.getDate("Policy?category_first=" + this.activeName);
			}
  }
};
</script>

<style scoped lang="scss">
.incubate {
  height: 100%;
  .incubate-tabs {
    // width: 452px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }
  .policey_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: '/';
        }
      }
    }
  }
}
</style>
